var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"parameters-list"},[_vm._m(0),_c('PParametersList',{attrs:{"sections":_vm.sections,"toggles":_vm.toggles}})],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"parameters-list__heading"},[_c('div',{staticClass:"container"},[_c('h1',[_vm._v("Paramètres")])])])
}]

export { render, staticRenderFns }